import * as Config from "./config";
import * as CommStatusEnum from "./CommStatusEnum";

const defaultTries = 1000;
let maxReadyStateTries = defaultTries;

/*!
 * sendMessage only if wsConn exists and in OPEN readyState
 */
const sendNewCommandMessage = function (command, data) {
    const token = Config.getProlineAppDataByKey('token');
    if (typeof token !== 'undefined') {
        data.token = token;
    }
    if(isWebsocketReady()) {
        window.wsConn.send(JSON.stringify({command: command, data: data}));
    }
};

const waitForSocketConnection = function(callback) {
    setTimeout(
        function () {
            if (window.wsConn.readyState === 1) {
                if (callback != null){
                    callback();
                }
            } else if (window.wsConn.readyState === 0) {
                if(--maxReadyStateTries > 0) {
                    waitForSocketConnection(callback);
                }
            }
        }, 10); // wait 10 miliseconds for the connection...
};

const isWebsocketReady = () => (window.wsConn instanceof WebSocket && window.wsConn.readyState === window.wsConn.OPEN);

const generateConnectionString = function () {
    const oldConnectionString = Config.getConnectionString();
    const token = Config.getProlineAppDataByKey('token');

    let connectionString = Config.getBaseConnectionString();
    if (typeof connectionString !== 'undefined') {
        connectionString += '/';
    }
    if (typeof token !== 'undefined' && typeof connectionString !== 'undefined') {
        connectionString += '?token=' + token;
    }
    if (typeof oldConnectionString === 'undefined' || connectionString !== oldConnectionString) {
        Config.setConnectionString(connectionString);
    }
    return connectionString;
};

const parseIncomingMessageData = (e) => {
    let msgData;
    try {
        msgData = JSON.parse(e.data);
    } catch (e) {
        msgData = {command: null, data: null, errors: null};
    }
    const command = msgData.command;
    const data = msgData.data;
    const errors = msgData.errors;
    switch (command) {
        case 'server-debug':
            console.debug(`onmessage::${command}`, data);
            break;
        case 'server-error':
            console.error(`onmessage::${command}`, data);
            break;
    }
    return {msgData: msgData, command: command, data: data, errors: errors};
};

const setCommIcoState = (state) => {
    const statusEl = $('[data-ws-status=on]');
    if(statusEl.length === 1) {
        statusEl.removeClass('text-danger text-success text-warning text-info');
        switch (state) {
            case CommStatusEnum.STATUS_ONLINE:
                statusEl.addClass('text-success');
                break;
            case CommStatusEnum.STATUS_CHECKING:
                statusEl.addClass('text-warning');
                break;
            case CommStatusEnum.STATUS_OFFLINE:
            default:
                statusEl.addClass('text-danger');
                break;
        }
    }
};

const showOnline = () => {
    setCommIcoState(CommStatusEnum.STATUS_ONLINE);
};

const showChecking = () => {
    setCommIcoState(CommStatusEnum.STATUS_CHECKING);
};

const showOffline = () => {
    setCommIcoState(CommStatusEnum.STATUS_OFFLINE);
};

const resetCounter = () => {
    maxReadyStateTries = defaultTries;
};

export {
    sendNewCommandMessage,
    generateConnectionString,
    parseIncomingMessageData,
    isWebsocketReady,
    waitForSocketConnection,
    showOffline,
    showOnline,
    showChecking,
    resetCounter,
};
